import { AvatarChip, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useCallback, useMemo } from "react";

import { AvatarPreset } from "@/types";
import { cn, getAvatarUrl } from "@/utils";

import { GroupMembersChatBot } from "./types";

interface IMemberChipProps {
  member: GroupMembersChatBot & { hasError?: boolean };
  subtitle?: string;
  editable: boolean;
  blurNSFW: boolean;
  onRemove: (id: string) => void;
}

const MemberChip = ({ member, subtitle, editable, blurNSFW, onRemove }: IMemberChipProps) => {
  const avatarUrl = getAvatarUrl(member.avatar, { preset: AvatarPreset.AVATAR_48X48 }) ?? undefined;

  const handleRemove = useCallback(() => {
    onRemove(member.id);
  }, [onRemove, member.id]);

  const chipClassNames = useMemo(() => ({ avatar: cn(member.avatarIsNsfw && blurNSFW && "blur-md") }), [member.avatarIsNsfw, blurNSFW]);

  return (
    <div className="flex flex-col items-center gap-1">
      <AvatarChip
        name={member.name}
        creatorUsername={member.creator_username}
        avatarSrc={avatarUrl}
        editable={editable}
        onRemove={handleRemove}
        hasError={member.hasError}
        classNames={chipClassNames}
      />
      {subtitle ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11">
          {subtitle}
        </Text>
      ) : null}
    </div>
  );
};

export default MemberChip;
